import { Box, Typography, ButtonBase, useMediaQuery } from "@mui/material"
import { useTheme } from "@mui/material/styles"

const FilmFestivalStickyCta = ({ onClick }: { onClick: () => void }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <Box
      sx={(theme) => ({
        position: "fixed",
        top: { xs: 30, md: 40 },
        right: { xs: 30, md: 40 },
        zIndex: 10,
      })}
    >
      <ButtonBase
        onClick={onClick}
        sx={(theme) => ({
          ...theme.typography["link.md"],
          "display": "flex",
          "alignItems": "center",
          "gap": 2,
          "minHeight": 49,
          "padding": theme.spacing(2, 4),
          "width": "100%",
          "backgroundColor": theme.palette["primary.800"].main,
          "borderRadius": 999,
          "transition": theme.transitions.create(["background-color", "border-color", "color"]),
          "&:hover": {
            backgroundColor: theme.palette["primary.900"].main,
          },
        })}
      >
        <Typography
          variant="body.md"
          fontWeight={600}
          sx={(theme) => ({
            color: theme.palette["neutral.100"].main,
            lineHeight: "160%!important",
            textTransform: "uppercase",
            fontSize: "13px",
          })}
        >
          {isMobile ? "Enter" : "Submit your film"}
        </Typography>
      </ButtonBase>
    </Box>
  )
}

export default FilmFestivalStickyCta
